module.exports = __webpack_public_path__ + "static/media/table-manger.7af01610.svg";